import { Modal } from 'antd';
import { useState } from 'react';
import { BaseButton } from '../../../UI/BaseButton';

type BreakSortModalProps = {
  sortColumn: string;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
};

export const SwitchToManualSortModal = ({ sortColumn, open, onOk, onCancel }: BreakSortModalProps) => {
  const [isLoading, setisLoading] = useState(false);

  return (
    <Modal
      title={<div className="text-brand-grey-dark text-base font-semibold">Switch to manual sorting?</div>}
      open={open}
      onOk={onOk}
      confirmLoading={isLoading}
      onCancel={onCancel}
      okButtonProps={{ danger: true }}
      width={640}
      centered
      footer={
        <div className="flex items-center justify-between">
          <BaseButton size="medium" type="secondary" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton size="medium" type="secondary" onClick={onOk} danger>
            Switch to manual sort
          </BaseButton>
        </div>
      }
    >
      <div className="mt-6 mb-8">
        <span className="text-brand-grey-dark text-sm font-normal">
          Tasks in this view are automatically sorted by{' '}
        </span>
        <span className="text-brand-grey-dark text-sm font-bold">{sortColumn}</span>
        <span className="text-brand-grey-dark text-sm font-normal">
          {' '}
          and changing the order of tasks will affect this sorting setting. If you proceed, your sort will be switched
          to manual.
        </span>
      </div>
    </Modal>
  );
};
